import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ApiService } from '@services';

/**
 * Admin users service.
 *
 * @author Ihar Kazlouski
 * @class AdminUsersServiceClass
 * @category Services
 */
var AdminUsersServiceClass = /*#__PURE__*/function () {
  function AdminUsersServiceClass() {
    _classCallCheck(this, AdminUsersServiceClass);
  }

  _createClass(AdminUsersServiceClass, [{
    key: "apiAdminUsersGet",
    value:
    /**
     * Admin console users get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<AdminUsersResponseType>>} admin console users.
     */
    function () {
      var _apiAdminUsersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet('/super-admins', _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiAdminUsersGet(_x) {
        return _apiAdminUsersGet.apply(this, arguments);
      }

      return apiAdminUsersGet;
    }()
    /**
     * Admin console users filter post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<AdminUsersResponseType>>} admin console users list promise.
     */

  }, {
    key: "apiSearchAdminUsersPost",
    value: function () {
      var _apiSearchAdminUsersPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiPost('/super-admins/search', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiSearchAdminUsersPost(_x2) {
        return _apiSearchAdminUsersPost.apply(this, arguments);
      }

      return apiSearchAdminUsersPost;
    }()
    /**
     * Partial update current admin info patch api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<string>>} current admin response promise.
     */

  }, {
    key: "apiUpdateAdminInfoPatch",
    value: function () {
      var _apiUpdateAdminInfoPatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiPatch("/admin-console-users/".concat(params.body.id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function apiUpdateAdminInfoPatch(_x3) {
        return _apiUpdateAdminInfoPatch.apply(this, arguments);
      }

      return apiUpdateAdminInfoPatch;
    }()
  }]);

  return AdminUsersServiceClass;
}();

var AdminUsersService = new AdminUsersServiceClass();
export { AdminUsersService };